<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Marcas - Inclusão</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'product-brands'}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>
    <form-product-brand :btnLabel="btnLabel"></form-product-brand>
</span>
</template>

<script>
import FormProductBrandComponent from "./partial/FormProductBrandComponent";

export default {
    name: "AddProductBrandComponent",
    data() {
        return {
            btnLabel: 'Incluir'
        }
    },
    methods: {

    },
    components: {
        formProductBrand: FormProductBrandComponent,
    }
};
</script>

<style scoped>

</style>
